module.exports = require("live/components/ui/admin/web-settings-card");